import { type MotionValue } from 'motion/react'
import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { type ProfileViewModel } from '@/features/iam/users/ProfileViewModel'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { Profile } from '@/features/iam/users/Profile'
import { ProfileNavContainer } from '@/features/iam/users/components/ProfileNav/ProfileNavContainer'

/**
 * What the profile pages receive from the profile layout.
 */
export interface ProfileOutletContext {
  vm: ProfileViewModel
  scrollOffset: MotionValue<number>
}

export interface ProfileContainerProps {
  vm: ProfileViewModel
}

export const ProfileContainer = observer(function ProfileContainer({
  vm,
}: ProfileContainerProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  const context = useMemo<ProfileOutletContext>(
    () => ({ vm, scrollOffset }),
    [vm, scrollOffset],
  )
  return (
    <Profile nav={<ProfileNavContainer vm={vm} />} scrollRef={scrollRef}>
      <Outlet context={context} />
    </Profile>
  )
})
